<template>
  <el-main></el-main>
</template>

<script>
export default {};
</script>

<style>
</style>